module.exports = __webpack_public_path__ + "__static/site-1783523783704/img/smile-icon.aad75095.svg";